import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAddBulkAppointmentsApi } from '../../api';
import { getCurrentCompanyId } from 'src/modules/companies/slices';
import DownloadCSV from './DownloadCSV';
import { VisuallyHiddenInput } from 'src/UIKit';

type DownloadCsvModalType = {
  error: boolean;
  setError: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: React.Dispatch<React.SetStateAction<void>>;
  refreshAppointments: () => void;
};

//const customFieldsLimit = 10000;

export default function ImportAppointments({
  error,
  setError,
  handleClose,
  refreshAppointments,
}: DownloadCsvModalType) {
  const selectedCompanyId = useSelector(getCurrentCompanyId);
  const [file, setFile] = useState<File | null>(null);
  const uploadCsvApi = useAddBulkAppointmentsApi();
  const [isAppointmentsUploading, setIsAppointmentsUploading] = useState(false);

  const formatHeaders = () => {
    const fields = "name,type,start date,end date,description,location,notification,phone number,confirmed";
    return fields.replace(/,\s*$/, "");
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(false);
    const file = event.target?.files?.[0];
    if (file) {
      setFile(file);
    }
  };

  const addCsvAppointments = async () => {
    const formData = new FormData();
    file && formData.append("file", file);
    if (formData && selectedCompanyId) {
      setIsAppointmentsUploading(true);
      uploadCsvApi(formData, selectedCompanyId)
        .then(() => {
          setIsAppointmentsUploading(false);
          handleClose();
          refreshAppointments();
        })
        .catch((e) => {
          if (e.error === "validation") {
            setError(true);
          }
        })
        .finally(() => {
          setIsAppointmentsUploading(false);
          handleClose();
        });
    }
  };

  return (
    <Fragment>
      <span style={{ marginBottom: "20px" }}>
        {"Click "}
        <DownloadCSV data={formatHeaders()} fileName="Calendar-Events-CSV-example" />
        {` to download the template for importing calendar events.`}
      </span>
      <Button
        component="label"
        style={{ width: "250px", marginBottom: "20px" }}
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
      >
        Upload file
        <VisuallyHiddenInput type="file" onChange={handleFileUpload} accept=".csv" />
      </Button>
      {file?.name && <Box mt={-1.25} mb={1.25}>{`File: ${file?.name}`}</Box>}
      {error && (
        <FormLabel error={true} style={{ marginTop: "10px", textAlign: "center" }}>
          {
            "Your list of appoinments were unable to be uploaded. Please check the file for issues or try reducing the number of appoinments included in your upload."
          }
        </FormLabel>
      )}
      <Button
        variant="contained"
        style={{
          width: "150px",
          textAlign: "center",
          alignSelf: "flex-end",
        }}
        onClick={addCsvAppointments}
        disabled={!file || isAppointmentsUploading}
      >
        {isAppointmentsUploading ? <CircularProgress size={25} /> : "Import"}
      </Button>
    </Fragment>
  );
}
